import http from "@/api/http.js";

function listByStartTimeAndEndTime(startTime, endTime) {
  return http({
    url: "/HmsCheckinTenant/ListByStartTimeAndEndTime",
    method: "get",
    params: {
      startTime: startTime,
      endTime: endTime,
    },
  });
}

function deleteById(id) {
  return http({
    url: "/HmsCheckinTenant/DeleteById/" + id,
    method: "post"
  });
}

export default {
  listByStartTimeAndEndTime,
  deleteById
};
